import * as React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import type { VariantProps } from 'class-variance-authority';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type Variants = VariantProps<typeof buttonVariants>;

/**
 * Router link styled as a button: a convenience for `<Link className={buttonVariants(...)}>`
 * (equivalent to `<Button asChild><Link/></Button>`) that keeps the variant props on the link.
 */
export function LinkButton({
  variant,
  size,
  className,
  ...props
}: LinkProps & Variants & React.RefAttributes<HTMLAnchorElement>) {
  return <Link className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}

/** External anchor styled as a button (opens in a new tab). */
export function ExternalLinkButton({
  variant,
  size,
  className,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & Variants) {
  return (
    <a
      target="_blank"
      rel="noreferrer"
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
